import React, { useState, useEffect } from 'react';
import './Home.css';
import TopLinks from '../Component/TopLinks';
import character from '../assets/character.png';
import logo from '../assets/starw1.png';
import Navbar from '../Component/Navbar';
import copyIcon from '../assets/copyIcon.png';

const Home = () => {
  const [pageLoaded, setPageLoaded] = useState(false);
  const [showCopiedMessage, setShowCopiedMessage] = useState(false); // State for copy notification
  const contractAddress = ''; // Contract address

  useEffect(() => {
    setPageLoaded(true);
  }, []);

  const copyToClipboard = () => {
    navigator.clipboard.writeText(contractAddress).then(() => {
      setShowCopiedMessage(true); // Show the copy message
      setTimeout(() => {
        setShowCopiedMessage(false); // Hide the message after 2 seconds
      }, 2000);
    }).catch(err => {
      console.error('Failed to copy: ', err);
    });
  };

  return (
    <div className={`Home ${pageLoaded ? 'loaded' : ''}`}>
      <div className={`HomeTopLinksContainer ${pageLoaded ? 'fade-in' : ''}`}>
        <div></div>
        <div className={`HomeNavbar ${pageLoaded ? 'fade-in' : ''}`}>
          <Navbar />
        </div>
        <div className={`HomeTopLinks ${pageLoaded ? 'fade-in' : ''}`}>
          <TopLinks />
        </div>
      </div>
      <div className={`HomeContentContainer ${pageLoaded ? 'fade-in' : ''}`}>
        <div className={`HomeContentImageContainer ${pageLoaded ? 'pop-in' : ''}`}>
          <img className="HomeContentImage" src={character} alt="character" />
        </div>
        <div className={`HomeContentDescription ${pageLoaded ? 'pop-in' : ''}`}>
          <div className="HomeContentText">
            <div className="HomeContentTextTitle">
              <div className="titleHome">ALF</div>
              <div className="titleHomeText">the Alpha</div>
            </div>
            <div className="HomeContentTextDescription">
              <div className="descriptionHome">Meet ALF, the Starkware mascot. A degen wolf with a geeky edge.</div>
            </div>
          </div>
          <a href="https://app.avnu.fi/en?tokenFrom=0x04718f5a0fc34cc1af16a1cdee98ffb20c31f5cd61d6ab07201858f4287c938d&tokenTo=0x78d7dfcddb44667153513bd837ff534ef395484f4b6cf28faa25b2c46e063d9" className="HomeContentBuyButtonLink" target="_blank" rel="noopener noreferrer">
            BUY
          </a>
          {/* <div className="HomeContentContractCopy" onClick={copyToClipboard}>
            <div className="HomeContentContractCopyTitle">Contract Address</div>
            <div className="HomeContentContractCopyAddress">{contractAddress}</div>
            <img src={copyIcon} alt="Copy Icon" className="HomeContentContractCopyIcon" />
            {showCopiedMessage && (
            <div className="copy-notification">Copied!</div> // Notification message
            )}
          </div> */}

        </div>
      </div>
    </div>
  );
};

export default Home;
